<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import {lookup2,disabledBeforeTodayDates} from '@/apis/common'
import {saveOrder} from '@/apis/order'
import LanguageSwitch from '../../components/language-switch';
import {
  required
} from "vuelidate/lib/validators";
/**
 * Form Repeater component
 */
export default {
  page: {
    title: "AWS Application Form",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout,Multiselect,LanguageSwitch},
  validations: {
    form: {
      clientName: { 
            required,
      },
      taxCode: { 
        check(value){
            if (localStorage.getItem('language')!="zh-CN"&&value!=null && value.trim().length === 0) {
              return false;
            }else{
              return true;
            }                
        },
      },
      country: { 
        required,
      },
      address: { 
        required,
      },
      contact: { 
            required,
      },
      mobile: { 
            required,
      },
      email: { 
            required,
      },
      orderDetail:{
          factoryName:{
          required
        },
          certLev:{
          required
        },
          certType:{
          required
        },
          auditType:{
          required
        },
          address:{
          required
        },
          employees:{
          required
        },
          occupiedArea:{
          required
        },
          mainProducts:{
          required
        },
          mainManufacture:{
          required
        },
          wastewater:{
          required
        }
        },      
    },
  },
  props:{
    sales:{
      type: String,
      required: false
    }
  },
  data() {
    return {
      title: "Alliance for Water Stewardship Certification",
      orderNo:null,
      clientNo:null,
      showTaxCode:false,
      disabledDates: disabledBeforeTodayDates,
      form:{
        orderId:null,
        orderType:"AWS",
        orderSource:"ON-LINE",
        orderStatus:'N',
        paymentStatus:'Y',
        sales:"",
        handleSales:"",
        orderDetail:{
          factoryName:"",
          certLev:"",
          certType:"",
          auditType:"",
          wtSource:"",
          wwChannel:"",  
          referenceNumber:"",
          address:"",
          employees:"",
          occupiedArea:"",
          mainProducts:"",
          mainManufacture:"",
          wastewater:"",
          annualWater:"",    
          wastewaterReused:"",
          wastewaterTreatmentPlant:"",       
          reason:"",
        },
        clientId:null,
        clientName:"",
        clientNameEn:"",
        taxCode:"",
        country:"",
        province:"",
        city:"",
        station:"",
        salesTag:"",        
        address:"",
        addressEn:"",
        promoteBrand:"",
        companyInfo:{
          productType:"",
        },
        contact:"",
        email:"",
        mobile:"",
        title:"",
        department:"",
        formFile:""
      },     
      submitted:false,
      success:false,
      lookupRawData:{},
      lookupData:{
        certLev:[],
        certType:[],
        auditType:[],
        wtSource:[],
        wwChannel:[],                
        travel:[],
        cnty:[]
      },
      lookupDataSelected:{
        certLev:[],
        certType:[],
        auditType:[],
        wtSource:[],
        wwChannel:[],     
        cnty:[]
      },
    };
  },
  created(){
    if(this.$route.query.tag!=undefined){
      this.form.salesTag = this.$route.query.tag;
    }
    this.init();
  },
  watch:{
    "lookupDataSelected.cnty"(){
      if(this.lookupDataSelected.cnty.value!=undefined){
        this.form.country = this.lookupDataSelected.cnty.value
      }
    },
    "form.address"(){
      if(this.form.address.indexOf("省")!=-1||this.form.address.indexOf("市")!=-1){
        let address = this.form.address.replace("，",",").split("市")[0].replace("中国","").trim()
        if(address.indexOf("省")!=-1){
          let province_city = address.split("省")
          this.form.city = ""||province_city[1].trim()
        }else{
          this.form.city = address
        }
      }
    },    
  },
  methods: {
    async init(){
      // 初始化数据字典
      this.lookupRawData = await lookup2("AWS-CERT-LEV,AWS-CERT-TYPE,AWS-AUDIT-TYPE,AWS-WT-SOURCE,AWS-WW-CHANNEL,CNTY");
      this.lookupData.certLev = this.lookupRawData["AWS-CERT-LEV"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.certType = this.lookupRawData["AWS-CERT-TYPE"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.auditType = this.lookupRawData["AWS-AUDIT-TYPE"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.wtSource = this.lookupRawData["AWS-WT-SOURCE"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.wwChannel = this.lookupRawData["AWS-WW-CHANNEL"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.cnty = this.lookupRawData["CNTY"].map(item=>{return {...item,labelCn:item.label}});
      this.changeLookupLanguage()
    },
    changeLookupLanguage(){
      if(localStorage.getItem('language')=="zh-CN"){
        this.showTaxCode = false;
        this.lookupData.certLev = this.lookupData.certLev.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.certType = this.lookupData.certType.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.auditType = this.lookupData.auditType.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.wtSource = this.lookupData.wtSource.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.wwChannel = this.lookupData.wwChannel.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.cnty = this.lookupData.cnty.map(item=>{return {...item,label:item.labelCn}});
      }else{
        this.showTaxCode = true;
        this.lookupData.certLev = this.lookupData.certLev.map(item=>{return {...item,label:item.labelEn}});
        this.lookupData.certType = this.lookupData.certType.map(item=>{return {...item,label:item.labelEn}});
        this.lookupData.auditType = this.lookupData.auditType.map(item=>{return {...item,label:item.labelEn}});
        this.lookupData.wtSource = this.lookupData.wtSource.map(item=>{return {...item,label:item.labelEn}});
        this.lookupData.wwChannel = this.lookupData.wwChannel.map(item=>{return {...item,label:item.labelEn}});        
        this.lookupData.cnty = this.lookupData.cnty.map(item=>{return {...item,label:item.labelEn}});
      }
    },
    handleSave() {
      this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
            this.success = false
            return;
        } else {
          let params = {...this.form}
          let orderDetail = {...this.form.orderDetail}
          if(this.lookupDataSelected.certLev.value!=undefined){
            orderDetail.certLev = this.lookupDataSelected.certLev.value
          }
          if(this.lookupDataSelected.certType.value!=undefined){
            orderDetail.certType = this.lookupDataSelected.certType.value
          }
          if(this.lookupDataSelected.auditType.value!=undefined){
            orderDetail.auditType = this.lookupDataSelected.auditType.value
          }
          if(this.lookupDataSelected.wtSource.value!=undefined){
            orderDetail.wtSource = this.lookupDataSelected.wtSource.value
          }        
          if(this.lookupDataSelected.wwChannel.value!=undefined){
            orderDetail.wwChannel = this.lookupDataSelected.wwChannel.value
          }
          if(this.lookupDataSelected.cnty.value!=undefined){
            params.country = this.lookupDataSelected.cnty.value
          }                    
          params.sales = this.sales
          params.companyInfo = JSON.stringify(this.form.companyInfo)
          params.language = localStorage.getItem('language')
          params.orderDetail = JSON.stringify(orderDetail)
          this.success = true
          saveOrder('AWS',params).then(()=>{
            Swal.fire(this.$t("common.successMsg"),"", "success");
          }).catch(()=>{
            this.success = false;
          })
        }
    },
    handleGoHome(){
      this.$router.push({
          name: 'home',
      })
    }

  },
};
</script>

<template>
  <Layout>
    <div class="row  mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" style="padding-top: 0px;">
                        <div class="row">
                          <div class="col-lg-2 col-sm-1 logo-col" >
                            <a href="http://www.greenpont.com/" class="logo">
                                <span class="logo-sm">
                                  <img src="@/assets/images/logo-sm.svg" alt height="22" />
                                </span>
                                <span class="logo-lg">
                                  <img src="@/assets/images/logo-dark.svg" alt height="36" />
                                </span>
                            </a>
                          </div>
                          <div class="col-lg-8 col-sm-10 text-center" >
                            <h5 class="card-title" style="line-height: 70px;"><span class="logo-icon">
                              <a href="http://www.greenpont.com/"><img src="@/assets/images/logo-sm.svg" alt height="22" /></a>
                              </span>{{$t("aws.formName")}}</h5>
                          </div>
                        </div>
                        <language-switch @change="changeLookupLanguage"></language-switch>
                        <form class="needs-validation">
                          <div class="card border shadow-none mb-5">
                            <div class="card-header d-flex align-items-center">
                                <div class="flex-shrink-0 me-3">
                                    <div class="avatar">
                                        <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                            01
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-grow-1">
                                    <h5 class="card-title">{{$t("aws.applicantInformation")}}</h5>
                                </div>
                            </div>
                            <div class="card-body">
                                <div>
                                    <div class="row">
                                        <div class="col-lg-6 mb-3">
                                                <label class="form-label" for="gen-info-name-input">{{$t("common.clientNameLocal")}}:</label>
                                                <input type="text" class="form-control" id="gen-info-name-input" v-model="form.clientName"
                                                :class="{
                                                    'is-invalid': submitted && $v.form.clientName.$error,
                                                }">
                                                <div
                                                    v-if="submitted && $v.form.clientName.$error"
                                                    class="invalid-feedback"
                                                    >
                                                        <span v-if="!$v.form.clientName.required">
                                                          {{$t("common.clientNameLocalError")}}.
                                                        </span>
                                                </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="mb-3">
                                                <label class="form-label" for="gen-info-name-en-input">{{$t("common.clientNameEn")}}:</label>
                                                <input type="text" class="form-control" id="gen-info-name-en-input" v-model="form.clientNameEn">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-taxcode-input">{{$t("common.taxCode")}}:</label>
                                              <input type="text" class="form-control" id="gen-info-taxcode-input" v-model="form.taxCode"
                                              :class="{
                                                  'is-invalid': submitted && $v.form.taxCode.$error,
                                              }">
                                              <div
                                                  v-if="submitted && $v.form.taxCode.$error"
                                                  class="invalid-feedback"
                                                  >
                                                      <span v-if="!$v.form.taxCode.check">
                                                        {{$t("common.taxCodeError")}}.
                                                      </span>
                                              </div>
                                      </div>
                                  </div>                                  
                                    <div class="row">
                                      <div class="col-lg-6 mb-3">
                                        <label class="form-label" for="gen-info-country-input">{{$t("common.country")}}:</label>
                                          <multiselect 
                                          id="gen-info-country-input"
                                          v-model="lookupDataSelected.cnty" 
                                          :options="lookupData.cnty"
                                          label="label"
                                          track-by="value"
                                          :class="{
                                                  'is-invalid': submitted && $v.form.country.$error,
                                              }"
                                          ></multiselect>
                                          <div
                                              v-if="submitted && $v.form.country.$error"
                                              class="invalid-feedback"
                                              >
                                                  <span v-if="!$v.form.country.required">
                                                    {{$t("common.countryError")}}.
                                                  </span>
                                          </div>
                                      </div>
                                      <div class="col-lg-6 mb-3">
                                            <label class="form-label" for="gen-info-province-input">{{$t("common.province")}}:</label>
                                            <input type="text" class="form-control" id="gen-info-province-input" v-model="form.province">
                                    </div>                                     
                                  </div>                            
                                    <div class="row">
                                        <div class="col-lg-6 mb-3">
                                                <label class="form-label" for="gen-info-address-input">{{$t("common.addressLocal")}}:</label>
                                                <input type="text" class="form-control" id="gen-info-address-input" v-model="form.address"
                                                :class="{
                                                    'is-invalid': submitted && $v.form.address.$error,
                                                }">
                                                <div
                                                    v-if="submitted && $v.form.address.$error"
                                                    class="invalid-feedback"
                                                    >
                                                        <span v-if="!$v.form.address.required">
                                                          {{$t("common.addressLocalError")}}.
                                                        </span>
                                                </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="mb-3">
                                                <label class="form-label" for="gen-info-address-en-input">{{$t("common.addressEn")}}:</label>
                                                <input type="text" class="form-control" id="gen-info-address-en-input" v-model="form.addressEn">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-lg-12 mb-3">
                                              <label class="form-label" for="gen-info-station-input">{{$t("common.station")}}:</label>
                                              <input type="text" class="form-control" id="gen-info-station-input" v-model="form.station">
                                      </div>                                            
                                  </div> 
                                  
                                  <div class="row">
                                        <div class="col-lg-6 mb-3">
                                                <label class="form-label" for="gen-info-contact-input">{{$t("common.contact")}}:</label>
                                                <input type="text" class="form-control" id="gen-info-contact-input" v-model="form.contact"
                                                :class="{
                                                    'is-invalid': submitted && $v.form.contact.$error,
                                                }">
                                                <div
                                                    v-if="submitted && $v.form.contact.$error"
                                                    class="invalid-feedback"
                                                    >
                                                        <span v-if="!$v.form.contact.required">
                                                          {{$t("common.contactError")}}.
                                                        </span>
                                                </div>
                                        </div>
                                        <div class="col-lg-6 mb-3">
                                          <label class="form-label" for="gen-info-title-input">{{$t("common.title")}}:</label>
                                          <input type="text" class="form-control" id="gen-info-title-input" v-model="form.title">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6 mb-3">
                                                <label class="form-label" for="gen-info-mobile-input">{{$t("common.mobile")}}:</label>
                                                <input type="text" class="form-control" id="gen-info-mobile-input" v-model="form.mobile"
                                                :class="{
                                                    'is-invalid': submitted && $v.form.mobile.$error,
                                                }">
                                                <div
                                                    v-if="submitted && $v.form.mobile.$error"
                                                    class="invalid-feedback"
                                                    >
                                                        <span v-if="!$v.form.mobile.required">
                                                          {{$t("common.mobileError")}}.
                                                        </span>
                                                </div>
                                        </div>
                                        <div class="col-lg-6 mb-3" >
                                                <label class="form-label" for="gen-info-email-input">{{$t("common.email")}}:</label>
                                                <input type="text" class="form-control" id="gen-info-email-input"  v-model="form.email"
                                                :class="{
                                                    'is-invalid': submitted && $v.form.email.$error,
                                                }">
                                                <div
                                                    v-if="submitted && $v.form.email.$error"
                                                    class="invalid-feedback"
                                                    >
                                                        <span v-if="!$v.form.email.required">
                                                          {{$t("common.emailError")}}.
                                                        </span>
                                                </div>
                                        </div>
                                    </div>                          
                                </div>
                            </div>
                        </div>
                      <div class="card border shadow-none mb-5">
                            <div class="card-header d-flex align-items-center">
                                <div class="flex-shrink-0 me-3">
                                    <div class="avatar">
                                        <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                            02
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-grow-1">
                                    <h5 class="card-title">{{$t("aws.facility")}}</h5>
                                </div>
                            </div>
                            <div class="card-body">
                              <div class="mb-3">
                                <label class="form-label mb-3 d-flex">{{$t("aws.desiredCertificationLevel")}}:</label>
                                <div class="form-check form-check-inline" v-for="(item,index) in lookupData.certLev" :key="index">
                                  <input
                                    type="radio"
                                    class="form-check-input"
                                    :value="item.value"
                                    v-model="form.orderDetail.certLev"
                                  />
                                  <label class="form-check-label"
                                    >{{item.label}}</label
                                  >
                                </div>
                                <div
                                    v-if="submitted && $v.form.orderDetail.certLev.$error"
                                    class="invalid-feedback" style="display: block;"
                                    >
                                        <span v-if="!$v.form.orderDetail.certLev.required">
                                          {{$t("aws.certLevError")}}.
                                        </span>
                                </div>
                              </div>

                              <div class="mb-3">
                                <label class="form-label mb-3 d-flex">{{$t("aws.certificationType")}}:</label>
                                <div class="form-check form-check-inline" v-for="(item,index) in lookupData.certType" :key="index">
                                  <input
                                    type="radio"
                                    class="form-check-input"
                                    :value="item.value"
                                    v-model="form.orderDetail.certType"
                                  />
                                  <label class="form-check-label"
                                    >{{item.label}}</label
                                  >
                                </div>
                                <div
                                    v-if="submitted && $v.form.orderDetail.certType.$error"
                                    class="invalid-feedback" style="display: block;"
                                    >
                                        <span v-if="!$v.form.orderDetail.certType.required">
                                          {{$t("aws.certTypeError")}}.
                                        </span>
                                </div>                        
                              </div>
                              <div class="mb-3">
                                <label class="form-label mb-3 d-flex">{{$t("aws.auditType")}}:</label>
                                <div class="form-check form-check-inline" v-for="(item,index) in lookupData.auditType" :key="index">
                                  <input
                                    type="radio"
                                    class="form-check-input"
                                    :value="item.value"
                                    v-model="form.orderDetail.auditType"
                                  />
                                  <label class="form-check-label"
                                    >{{item.label}}</label
                                  >
                                </div>
                                <div
                                    v-if="submitted && $v.form.orderDetail.auditType.$error"
                                    class="invalid-feedback" style="display: block;"
                                    >
                                        <span v-if="!$v.form.orderDetail.auditType.required">
                                          {{$t("aws.auditTypeError")}}.
                                        </span>
                                </div>                             
                              </div>
                              <div class="row" v-if="form.orderDetail.auditType=='T'">
                                <div class="col-lg-12 mb-3">
                                  <label class="form-label mb-3 d-flex">{{$t("aws.reason")}}:</label>
                                  <input type="text" class="form-control" v-model="form.orderDetail.reason">                
                                </div>
                              </div>                             
                              <div class="row">
                                  <div class="col-lg-6 mb-3">
                                          <label class="form-label" for="gen-info-name-input">{{$t("aws.factoryName")}}:</label>
                                          <input type="text" class="form-control" id="gen-info-name-input" v-model="form.orderDetail.factoryName"
                                          :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.factoryName.$error,
                                          }">
                                          <div
                                              v-if="submitted && $v.form.orderDetail.factoryName.$error"
                                              class="invalid-feedback"
                                              >
                                                  <span v-if="!$v.form.orderDetail.factoryName.required">
                                                    {{$t("aws.factoryNameError")}}.
                                                  </span>
                                          </div>
                                  </div>
                                  <div class="col-lg-6">
                                      <div class="mb-3">
                                          <label class="form-label">{{$t("aws.address")}}:</label>
                                          <input type="text" class="form-control" v-model="form.orderDetail.address"
                                          :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.address.$error,
                                          }">
                                          <div
                                              v-if="submitted && $v.form.orderDetail.address.$error"
                                              class="invalid-feedback"
                                              >
                                                  <span v-if="!$v.form.orderDetail.address.required">
                                                    {{$t("aws.addressError")}}.
                                                  </span>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <div class="row">
                                  <div class="col-lg-4 mb-3">
                                          <label class="form-label" for="gen-info-name-input">{{$t("aws.referenceNumber")}}:</label>
                                          <input type="text" class="form-control" v-model="form.orderDetail.referenceNumber">
                                  </div>
                                  <div class="col-lg-4">
                                      <div class="mb-3">
                                          <label class="form-label">{{$t("aws.employees")}}:</label>
                                          <input type="text" class="form-control" v-model="form.orderDetail.employees"
                                          :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.employees.$error,
                                          }">
                                          <div
                                              v-if="submitted && $v.form.orderDetail.employees.$error"
                                              class="invalid-feedback"
                                              >
                                                  <span v-if="!$v.form.orderDetail.employees.required">
                                                    {{$t("aws.employeesError")}}.
                                                  </span>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-lg-4">
                                      <div class="mb-3">
                                          <label class="form-label">{{$t("aws.occupiedArea")}}:</label>
                                          <input type="text" class="form-control" v-model="form.orderDetail.occupiedArea"
                                          :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.occupiedArea.$error,
                                          }">
                                          <div
                                              v-if="submitted && $v.form.orderDetail.occupiedArea.$error"
                                              class="invalid-feedback"
                                              >
                                                  <span v-if="!$v.form.orderDetail.occupiedArea.required">
                                                    {{$t("aws.occupiedAreaError")}}.
                                                  </span>
                                          </div>
                                      </div>
                                  </div>                          
                              </div>

                              <div class="row">
                                  <div class="col-lg-6 mb-3">
                                      <label class="form-label">{{$t("aws.mainProducts")}}:</label>
                                      <input type="text" class="form-control"   v-model="form.orderDetail.mainProducts"
                                      :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.mainProducts.$error,
                                          }">
                                          <div
                                              v-if="submitted && $v.form.orderDetail.mainProducts.$error"
                                              class="invalid-feedback"
                                              >
                                                  <span v-if="!$v.form.orderDetail.mainProducts.required">
                                                    {{$t("aws.mainProductsError")}}.
                                                  </span>
                                          </div>
                                  </div>
                                  <div class="col-lg-6 mb-3">
                                      <label class="form-label" >{{$t("aws.mainManufacture")}}:</label>
                                      <input type="text" class="form-control"  v-model="form.orderDetail.mainManufacture"
                                      :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.mainManufacture.$error,
                                          }">
                                          <div
                                              v-if="submitted && $v.form.orderDetail.mainManufacture.$error"
                                              class="invalid-feedback"
                                              >
                                                  <span v-if="!$v.form.orderDetail.mainManufacture.required">
                                                    {{$t("aws.mainManufactureError")}}.
                                                  </span>
                                          </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-lg-6 mb-3">
                                      <label class="form-label">{{$t("aws.wastewater")}}:</label>
                                      <input type="text" class="form-control"   v-model="form.orderDetail.wastewater"
                                      :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.wastewater.$error,
                                          }">
                                          <div
                                              v-if="submitted && $v.form.orderDetail.wastewater.$error"
                                              class="invalid-feedback"
                                              >
                                                  <span v-if="!$v.form.orderDetail.wastewater.required">
                                                    {{$t("aws.wastewaterError")}}.
                                                  </span>
                                          </div>
                                  </div>
                                  <div class="col-lg-6 mb-3">
                                      <label class="form-label" >{{$t("aws.annualWater")}}:</label>
                                      <input type="text" class="form-control"  v-model="form.orderDetail.annualWater">
                                  </div>
                              </div>
                              <div class="row">
                                <div class="col-lg-12 mb-3">
                                  <label class="form-label mb-3 d-flex">{{$t("aws.sourceWater")}}:</label>
                                  <div class="form-check form-check-inline" v-for="(item,index) in lookupData.wtSource" :key="index">
                                    <input
                                      type="radio"
                                      class="form-check-input"
                                      :value="item.value"
                                      v-model="form.orderDetail.wtSource"
                                    />
                                    <label class="form-check-label"
                                      >{{item.label}}</label
                                    >
                                  </div>                          
                                </div>
                              </div>                      
                              <div class="row">
                                  <div class="col-lg-4 mb-3" v-html="$t('aws.wastewaterReused')" style="font-weight: bold;">
                                  </div>
                                  <div class="col-lg-8 mb-3">
                                    <textarea rows="5" class="form-control" v-model="form.orderDetail.wastewaterReused"></textarea>
                                  </div>
                              </div>
                              <div class="row">
                                <div class="col-lg-12 mb-3">
                                  <label class="form-label mb-3 d-flex">{{$t("aws.wastewaterTreatmentPlant")}}:</label>
                                  <input type="text" class="form-control" v-model="form.orderDetail.wastewaterTreatmentPlant">                
                                </div>
                              </div>     
                              <div class="row">
                                <div class="col-lg-12 mb-3">
                                  <label class="form-label mb-3 d-flex">{{$t("aws.dischargedWastewater")}}:</label>
                                  <div class="form-check form-check-inline" v-for="(item,index) in lookupData.wwChannel" :key="index">
                                    <input
                                      type="radio"
                                      class="form-check-input"
                                      :value="item.value"
                                      v-model="form.orderDetail.wwChannel"
                                    />
                                    <label class="form-check-label"
                                      >{{item.label}}</label
                                    >
                                  </div>                          
                                </div>
                              </div>                                      
                            </div>
                        </div>
                          </form>
                          <div>
                              <button type="button" class="btn btn-primary w-sm" @click="handleSave" :disabled="success" >{{$t("common.submit")}}</button> {{$t("common.hotline")}}: +86 755 21608956/ +84 932 130 677
                              <button type="button" class="btn btn-btn-secondary w-sm" @click="handleGoHome" v-if="false">{{$t("common.moreService")}}</button>
                          </div>
                    </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
label{
  font-weight: bold;
}
label.form-check-label{
  font-weight: normal;
}
.is-invalid .mx-input-wrapper .mx-input{
    border: 1px solid #ec4561 !important;
  }
  .is-invalid .mx-input-wrapper .mx-icon-calendar{
    color: #ec4561 !important;
  }
  .is-invalid .multiselect__tags{
    border:1px solid #ec4561 !important;
  }
</style>
